import { resourceAllocationAggregationRangesEnum } from '@linearb/linjs-common';
import { PM_PROVIDERS } from 'common/constants/constants';
import {
  azureBoardsViewer,
  jiraViewer
} from 'components/hooks/PM/pm-provider-viewers';
import { startCase } from 'lodash';

export const GRANULARITY_TYPES = {
  MONTHLY: {
    key: 'MONTHLY',
    name: 'Monthly',
    apiValue: resourceAllocationAggregationRangesEnum.MONTH,
    single: 'month'
  },
  WEEKLY: {
    key: 'WEEKLY',
    name: 'Weekly',
    apiValue: resourceAllocationAggregationRangesEnum.WEEK,
    single: 'week'
  }
};

export const OVER_TIME_TYPES = {
  [PM_PROVIDERS.JIRA]: {
    ISSUES: {
      key: 'ISSUES',
      name: startCase(jiraViewer.ticket.plural),
      apiValue: 'issues'
    },
    STORY_POINTS: {
      key: 'STORY_POINTS',
      name: startCase(jiraViewer.storyPoint.plural),
      apiValue: 'story_points'
    }
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    ISSUES: {
      key: 'ISSUES',
      name: startCase(azureBoardsViewer.ticket.plural),
      apiValue: 'issues'
    },
    STORY_POINTS: {
      key: 'STORY_POINTS',
      name: startCase(azureBoardsViewer.storyPoint.plural),
      apiValue: 'story_points'
    }
  }
};
